import { useEffect, useState } from 'react';
import { STT_TOKEN_MAX_AGE } from '../constants';
import { getTokenOrRefresh } from './tokenUtil';
export default function useCCToken(roomName) {
    const [ccToken, setCcToken] = useState();
    const [ccDisabled, setCcDisabled] = useState(false);
    useEffect(() => {
        if (!roomName) {
            return setCcToken(undefined);
        }
        let refreshFn = () => getTokenOrRefresh(roomName)
            .then((z) => setCcToken(z))
            .catch(() => setCcDisabled(true));
        refreshFn();
        let interval = setInterval(refreshFn, STT_TOKEN_MAX_AGE * 1000);
        return () => clearInterval(interval);
    }, [roomName]);
    return { ccToken, ccDisabled };
}
